// '10142988', // 优惠码失效
// '10300502', // 优惠券或优惠码无效/当前选中的券不可叠加优惠，请选择其他券
// '10143310' // 您输入的优惠码无效
export const isCouponError = (code: string) =>
  ['10142988', '10300502', '10143310', 'giveaway_100'].includes(code) || code.startsWith('1014');
